module.exports = __webpack_public_path__ + "img/logo.12c3dca8.png";